import { tss } from "tss-react/mui";

export const useArticleCardStyles = tss.withName("ArticleCard").create(({ theme }) => ({
    root: {
        display: "block",
        textDecoration: "none",
        color: "inherit",
    },
    imageWrapper: {
        width: "100%",
        aspectRatio: "4 / 3",
        overflow: "hidden",
        backgroundColor: theme.palette.primary[50],
        marginBottom: theme.spacing(2),
    },
    image: {
        width: "100%",
        height: "100%",
        objectFit: "cover" as const,
    },
    category: {
        display: "inline-block",
        fontSize: "0.7rem",
        fontWeight: 700,
        color: theme.palette.primary.main,
        textTransform: "uppercase" as const,
        letterSpacing: "0.06em",
        marginBottom: theme.spacing(0.75),
    },
    title: {
        fontWeight: 700,
        marginBottom: theme.spacing(0.75),
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical" as const,
        overflow: "hidden",
    },
    excerpt: {
        color: theme.palette.text.secondary,
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical" as const,
        overflow: "hidden",
        marginBottom: theme.spacing(1),
    },
    meta: {
        fontSize: "0.75rem",
        color: theme.palette.text.disabled,
    },
}));
